import { ActionTree } from "vuex";
import { ServiceRecordState, ServiceRecord } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";
import Qs from "qs";

const actions: ActionTree<ServiceRecordState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    const messageId = params.messageId;
    delete params.messageId;
    const paramsHash = {
      params: params,
      paramsSerializer: function(params: object) {
        return Qs.stringify(params, { arrayFormat: "brackets" });
      },
    };

    return rootGetters["hcs/client"]
      .get(`/messages/${messageId}/service_records`, paramsHash)
      .then((response: AxiosResponse) => {
        const serviceRecords: ServiceRecord[] = response.data;
        commit("setServiceRecords", serviceRecords);
        return serviceRecords;
      });
  },
};

export default actions;
